<template>
  <div class="content create-payable-written-off-order">
    <div class="form-content">
      <a-tabs v-model="written_off_type" @change="init">
        <a-tab-pane key="PAYABLE_PAYMENT" :tab="$t('应付付款')" />
        <a-tab-pane key="PAYABLE_REFUND" :tab="$t('应付退款')" />
        <a-tab-pane key="PAYABLE_OFFSET" :tab="$t('应付对冲')" />
      </a-tabs>
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :code.sync="form_data.business_unit_code"
            :name.sync="form_data.business_unit_name"
            :placeholder="$t(`结算组织`)"
          />
        </a-col>
        <a-col :span="6">
          <CommonQuerySelect
            api="queryPurchaseSupplierList"
            :placeholder="$t('供应商')"
            :code.sync="form_data.payee_code"
            :name.sync="form_data.payee_name"
            valueName="supplier_code"
            labelName="supplier_name"
            :params="{ status: 1 }"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="opertate-btns flex-ct">
      <a-button type="primary" @click="onSubmit" :loading="save_loading">
        {{ $t('生成应付核销单') }}
      </a-button>
    </div>
    <div class="payable-list mt10">
      <div class="infoTitle" style="margin-bottom: 0">
        <div>
          <i class="leftLine"></i>
          <span>{{ $t('应付单列表') }}</span>
        </div>
        <div class="pr20 totla-amount flex-ct" v-if="total_payable_amount">
          <span style="font-weight: 400" class="fz14 mr10">{{ $t('本次核销金额') }}:</span>
          <PriceInput :showTxt="true" :value="total_payable_amount" />
        </div>
      </div>
      <CommonTable
        ref="CommonTableRef1"
        :columns.sync="columns1"
        :loading="loading1"
        :dataSource="table_data1"
        :showSelect="true"
        :scroll="{ x: 1500, y: scroll_height }"
        rowKey="doc_detail_id"
        :selectedRowKeys.sync="selected_row_keys1"
        :selectedRows.sync="selected_rows1"
        :total="total1"
        @select="selectRow1"
        @search="getList1"
      >
        <template v-slot:order_sn="{ record }">
          <a @click="viewDetail1(record)">{{ record.order_sn }}</a>
        </template>
        <template v-slot:payable_amount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functional_currency || record.settlement_currency"
            :value="record.payable_amount"
          />
        </template>
        <template v-slot:un_written_off_amount="{ record }">
          <PriceInput
            :showTxt="true"
            :showZero="true"
            :currency="record.functional_currency || record.settlement_currency"
            :value="record.un_written_off_amount"
          />
        </template>
        <template v-slot:amount="{ record }">
          <PriceInput
            v-if="record.un_written_off_amount > 0"
            :currency="record.functional_currency || record.settlement_currency"
            :value.sync="record.amount"
            @blur="
              (val) => {
                onBlur1(val, record)
              }
            "
          />
        </template>
      </CommonTable>
    </div>
    <div class="payment-note-list mt20">
      <div class="infoTitle" style="margin-bottom: 0">
        <div>
          <i class="leftLine"></i>
          <span>{{ table2_label }}</span>
        </div>
        <div class="pr20 totla-amount flex-ct" v-if="total_payment_amount">
          <span style="font-weight: 400" class="fz14 mr10">{{ $t('本次核销金额') }}:</span>
          <PriceInput :showTxt="true" :value="total_payment_amount" />
        </div>
      </div>
      <CommonTable
        ref="CommonTableRef2"
        :columns.sync="columns2"
        :loading="loading2"
        :dataSource="table_data2"
        :showSelect="true"
        :scroll="{ x: 1500, y: scroll_height }"
        rowKey="doc_detail_id"
        :selectedRowKeys.sync="selected_row_keys2"
        :selectedRows.sync="selected_rows2"
        :total="total2"
        @select="selectRow2"
        @search="getList2"
      >
        <template v-slot:refer_doc_sn="{ text, record }">
          <a @click="viewDetail2(record)">{{ text }}</a>
        </template>
        <template v-slot:refer_amount="{ text, record }">
          <PriceInput
            :value="text"
            :currency="record.functional_currency || record.settlement_currency"
            :showTxt="true"
          />
        </template>
        <template v-slot:un_written_off_amount="{ text, record }">
          <PriceInput
            :value="text"
            :currency="record.functional_currency || record.settlement_currency"
            :showTxt="true"
          />
        </template>
        <template v-slot:amount="{ record }">
          <PriceInput
            :value.sync="record.amount"
            :currency="
              record.payment_currency || record.receipt_currency || record.settlement_currency
            "
            @blur="onBlur2(record)"
          />
        </template>
      </CommonTable>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import debounce from '@/common/debounce'
import { add, subtract } from '@/common/number'
export default {
  name: 'CreatePayableWrittenOffOrder',
  components: { CommonTable },
  data() {
    return {
      written_off_type: 'PAYABLE_PAYMENT',
      form_data: {
        business_unit_code: undefined,
        business_unit_name: undefined,
        payee_code: undefined,
        payee_name: undefined,
        can_write_off: true,
      },
      table_data1: [],
      table_data2: [],
      selected_row_keys1: [],
      selected_row_keys2: [],
      selected_rows1: [],
      selected_rows2: [],
      total1: 0,
      total2: 0,
      loading1: false,
      loading2: false,
      save_loading: false,
    }
  },
  activated() {
    const type = this.$route.query.written_off_type
    if (type) {
      this.written_off_type = type
    }
    this.init()
  },
  computed: {
    ...mapGetters(['payableOrderTypeMapping', 'paymentNoteTypeMapping', 'receiptNoteTypeMapping']),
    scroll_height() {
      return window.innerHeight - 780
    },
    table2_label() {
      const map = {
        PAYABLE_PAYMENT: this.$t('付款单列表'),
        PAYABLE_REFUND: this.$t('收款单列表'),
        PAYABLE_OFFSET: this.$t('应付单列表'),
      }
      return map[this.written_off_type] || this.$t('关联单列表')
    },
    columns1() {
      return [
        {
          dataIndex: 'order_sn',
          title: this.$t('应付单号'),
          key: 'order_sn',
          scopedSlots: { customRender: 'order_sn' },
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'biz_time',
          customRender: (text) => text?.split(' ')?.[0],
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'order_type',
          width: 120,
          customRender: (text) => this.payableOrderTypeMapping[text],
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('供应商'),
          dataIndex: 'payee_name',
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('应付金额'),
          dataIndex: 'payable_amount',
          width: 150,
          scopedSlots: { customRender: 'payable_amount' },
        },
        {
          title: this.$t('未核销金额'),
          dataIndex: 'un_written_off_amount',
          width: 150,
          scopedSlots: { customRender: 'un_written_off_amount' },
        },
        {
          title: this.$t('本次核销金额'),
          dataIndex: 'amount',
          width: 200,
          scopedSlots: { customRender: 'amount' },
        },
      ]
    },
    columns2() {
      const sn_map = {
        PAYABLE_PAYMENT: { title: this.$t('付款单号'), dataIndex: 'payment_note_sn' },
        PAYABLE_REFUND: { title: this.$t('收款单号'), dataIndex: 'receipt_note_sn' },
        PAYABLE_OFFSET: { title: this.$t('应付单号'), dataIndex: 'order_sn' },
      }
      const config = sn_map[this.written_off_type] || {
        title: this.$t('关联单号'),
        dataIndex: 'refer_doc_sn',
      }
      const sn_key = config.dataIndex
      return [
        {
          title: config.title,
          dataIndex: config.dataIndex,
          scopedSlots: { customRender: 'refer_doc_sn' },
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('业务日期'),
          dataIndex: this.written_off_type === 'PAYABLE_PAYMENT' ? 'accounting_date' : 'biz_time',
          customRender: (text) => text?.split(' ')?.[0],
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'order_type',
          width: 120,
          customRender: (text) => {
            if (this.written_off_type === 'PAYABLE_PAYMENT')
              return this.paymentNoteTypeMapping[text]
            if (this.written_off_type === 'PAYABLE_REFUND') return this.receiptNoteTypeMapping[text]
            return this.payableOrderTypeMapping[text]
          },
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('供应商'),
          dataIndex: 'payee_name',
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('单据金额'),
          dataIndex:
            this.written_off_type === 'PAYABLE_PAYMENT'
              ? 'payable_amount'
              : this.written_off_type === 'PAYABLE_REFUND'
              ? 'receivable_amount'
              : 'payable_amount',
          scopedSlots: { customRender: 'refer_amount' },
          width: 150,
        },
        {
          title: this.$t('未核销金额'),
          dataIndex: 'un_written_off_amount',
          scopedSlots: { customRender: 'un_written_off_amount' },
          width: 150,
        },
        {
          title: this.$t('本次核销金额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: 200,
        },
      ]
    },
    total_payable_amount() {
      return this.selected_rows1.reduce((total, item) => {
        return add(total, item.amount)
      }, 0)
    },
    total_payment_amount() {
      return this.selected_rows2.reduce((total, item) => {
        return add(total, item.amount)
      }, 0)
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    init() {
      this.selected_row_keys1 = []
      this.selected_row_keys2 = []
      this.selected_rows1 = []
      this.selected_rows2 = []
      this.$nextTick(() => {
        this.searchHandle()
      })
    },
    searchHandle(page_no) {
      this.searchHandle1(page_no)
      this.searchHandle2(page_no)
    },
    searchHandle1(page_no) {
      this.selected_row_keys1 = []
      this.$refs.CommonTableRef1.queryList(page_no)
    },
    searchHandle2(page_no) {
      this.selected_row_keys2 = []
      this.$refs.CommonTableRef2.queryList(page_no)
    },
    mergeCells(text, data, key, index) {
      if (index !== 0 && text === data[index - 1]?.[key]) {
        return 0
      }
      let rowSpan = 1
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) break
        rowSpan++
      }
      return rowSpan
    },
    customCell1(key, record, index) {
      const rowSpan = this.mergeCells(record[key], this.table_data1, key, index)
      return rowSpan > 0
        ? { attrs: { rowSpan } }
        : { style: { display: 'none' }, attrs: { rowSpan: 0 } }
    },
    customCell2(key, record, index) {
      const rowSpan = this.mergeCells(record[key], this.table_data2, key, index)
      return rowSpan > 0
        ? { attrs: { rowSpan } }
        : { style: { display: 'none' }, attrs: { rowSpan: 0 } }
    },
    async getList1(params) {
      this.loading1 = true
      await http({
        url: api.getPayableList,
        data: {
          ...this.form_data,
          ...params,
          ...(this.written_off_type === 'PAYABLE_REFUND'
            ? { amountGlZero: 0 }
            : this.written_off_type === 'PAYABLE_OFFSET'
            ? { amountGlZero: 1 }
            : {}),
        },
        success: (res) => {
          let list = []
          ;(res.result.list || []).forEach((item) => {
            const plan_list = item.plan_list || item.payment_plan_list || []
            plan_list.forEach((elem) => {
              const un_written_off_amount = subtract(
                elem.payable_amount,
                elem.written_off_amount || 0
              )
              list.push({
                ...item,
                doc_detail_id: elem.id,
                payable_amount: elem.payable_amount,
                functional_currency: item.functional_currency || item.settlement_currency,
                un_written_off_amount,
                amount: un_written_off_amount,
              })
            })
          })
          this.table_data1 = list
          this.total1 = res.result.total
        },
      })
      this.loading1 = false
    },
    async getList2(params) {
      this.loading2 = true
      const url_map = {
        PAYABLE_PAYMENT: api.getPaymentNoteList,
        PAYABLE_REFUND: api.getReceiptNoteList,
        PAYABLE_OFFSET: api.getPayableList,
      }
      const url = url_map[this.written_off_type]
      if (!url) return
      await http({
        url,
        data: {
          ...this.form_data,
          ...params,
          ...(this.written_off_type === 'PAYABLE_OFFSET' ? { amountGlZero: 0 } : {}),
        },
        success: (res) => {
          let list = []
          ;(res.result.list || []).forEach((item) => {
            if (this.written_off_type === 'PAYABLE_PAYMENT') {
              const detail_list = item.items || item.detail_list || []
              detail_list.forEach((elem) => {
                const un_written_off_amount = subtract(
                  elem.payable_amount,
                  elem.written_off_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  payable_amount: elem.payable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            } else if (this.written_off_type === 'PAYABLE_REFUND') {
              const detail_list = item.items || item.detail_list || []
              detail_list.forEach((elem) => {
                const un_written_off_amount = subtract(
                  elem.receivable_amount,
                  elem.verified_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  receivable_amount: elem.receivable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            } else {
              // PAYABLE_OFFSET
              const plan_list = item.plan_list || item.payment_plan_list || []
              plan_list.forEach((elem) => {
                const un_written_off_amount = subtract(
                  elem.payable_amount,
                  elem.written_off_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  payable_amount: elem.payable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            }
          })
          this.table_data2 = list
          this.total2 = res.result.total
        },
      })
      this.loading2 = false
    },
    viewDetail1(record) {
      this.addPane({
        view: 'payableDetail/' + record.order_sn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.order_sn,
        },
        route: `/payableManage/payableDetail?id=${record.id}&sn=${record.order_sn}`,
      })
    },
    viewDetail2(record) {
      let view = 'paymentNoteDetail/' + record.payment_note_sn
      let sn = record.payment_note_sn
      let route = `/payableManage/paymentNoteDetail?id=${record.id}&sn=${sn}`

      if (this.written_off_type === 'PAYABLE_REFUND') {
        view = 'receiptNoteDetail/' + record.receipt_note_sn
        sn = record.receipt_note_sn
        route = `/receivableManage/receiptNoteDetail?id=${record.id}&sn=${sn}`
      } else if (this.written_off_type === 'PAYABLE_OFFSET') {
        view = 'payableDetail/' + record.order_sn
        sn = record.order_sn
        route = `/payableManage/payableDetail?id=${record.id}&sn=${sn}`
      }

      this.addPane({
        view,
        name: 'detailSn',
        query: {
          id: record.id,
          sn,
        },
        route,
      })
    },
    onSubmit: debounce(async function () {
      if (this.selected_row_keys1.length === 0) {
        this.$message.warning(this.$t('请选择应付单'))
        return
      }
      const label_map = {
        PAYABLE_PAYMENT: this.$t('请选择付款单'),
        PAYABLE_REFUND: this.$t('请选择收款单'),
        PAYABLE_OFFSET: this.$t('请选择被核销应付单'),
      }
      if (this.selected_row_keys2.length === 0) {
        this.$message.warning(label_map[this.written_off_type])
        return
      }
      this.save_loading = true
      const refer_doc_type_map = {
        PAYABLE_PAYMENT: 'PaymentNote',
        PAYABLE_REFUND: 'ReceiptNote',
        PAYABLE_OFFSET: 'PayableOrder',
      }
      await http({
        url: api.createWrittenOff,
        data: {
          written_off_type: this.written_off_type,
          main_doc_list: this.selected_rows1.map((item) => ({
            amount: item.amount,
            doc_detail_id: item.doc_detail_id,
            doc_id: item.id,
            doc_type: 'PayableOrder',
          })),
          refer_doc_list: this.selected_rows2.map((item) => ({
            amount: item.amount,
            doc_detail_id: item.doc_detail_id,
            doc_id: item.id,
            doc_type: refer_doc_type_map[this.written_off_type],
          })),
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`成功`),
              content: this.$t('核销单创建成功'),
            })
            this.init()
          } else {
            this.$error({
              title: this.$t(`错误`),
              content: this.$t(`创建失败`),
            })
          }
        },
      })
      this.save_loading = false
    }),
    backForm(back = 0) {
      if (back) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'payableList' })
    },
    selectRow1(selected_row_keys, selected_rows) {
      this.selected_row_keys1 = selected_row_keys
      this.selected_rows1 = selected_rows
    },
    selectRow2(selected_row_keys, selected_rows) {
      this.selected_row_keys2 = selected_row_keys
      this.selected_rows2 = selected_rows
    },
    onBlur1(val, record) {
      if (val && !this.selected_row_keys1.includes(record.doc_detail_id)) {
        this.selected_row_keys1.push(record.doc_detail_id)
        this.selected_rows1.push(record)
      }
    },
    onBlur2(record) {
      if (record.amount && !this.selected_row_keys2.includes(record.doc_detail_id)) {
        this.selected_row_keys2.push(record.doc_detail_id)
        this.selected_rows2.push(record)
      }
    },
  },
}
</script>
<style scoped>
.infoTitle {
  justify-content: space-between;
}
</style>
